package org.vreo.devicehub.features.core.data.protocolBuffer.mappers

import org.vreo.devicehub.features.core.domain.device.imageRequest.StaticImageRequest
import vreo.volt.protocol.StaticImage

/**
 * Extension function to map a [StaticImageRequest] to a [StaticImage]. Allows to map local data class to protocol
 * buffer message
 */
fun StaticImageRequest.toStaticImageProto(): StaticImage {
    return StaticImage(
        config = this.config ?: "",
        image_base64 = this.imageBase64 ?: ""
    )
}

/**
 * Extension function to map a [StaticImage] to a [StaticImageRequest]. Allows to map protocol buffer message to
 * local data class
 */
fun StaticImage.toStaticImageRequest(): StaticImageRequest {
    return StaticImageRequest(
        config = this.config,
        imageBase64 = this.image_base64
    )
}